<template>
  <v-main>
    <v-container fluid grid-list-xs pt-5>
      <v-layout row wrap justify-center align-center>
        <v-flex xs11 lg11>
          <h2>
            <v-icon color="#077893" @click="Fn_BackIndex" size="38"
              >mdi-chevron-left</v-icon
            >{{ $t("SettingBot.createbot") }}
          </h2>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center align-center pa-1>
        <v-flex xs11 lg11>
          <v-form ref="form" v-model="valid">
            <v-card class="rounded-lg">
              <v-card-title primary-title>
                {{ $t("SettingBot.botdata") }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pt-5">
                <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b>ชื่อบอท (ฺBot Name) <span style="color: red">*</span></b>
                    <v-text-field
                      outlined
                      dense
                      color="#077893"
                      v-model="BotName"
                      maxlength="200"
                      prepend-inner-icon="mdi-account-outline"
                      :rules="[(v) => !!v || 'กรุณากรอกข้อมูลให้ครบถ้วน']"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <!-- <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b>Business ID</b>
                    <v-text-field
                      hide-details
                      disabled
                      outlined
                      dense
                      color="#077893"
                      v-model="Business_ID"
                      prepend-inner-icon="mdi-account-outline"
                      :rules="[(v) => !!v || 'กรุณากรอกชื่อผู้ส่ง']"
                    ></v-text-field>
                  </v-flex>
                </v-layout> -->
                <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b>Bot ID <span style="color: red">*</span></b>
                    <v-text-field
                      outlined
                      dense
                      color="#077893"
                      v-model="Bot_ID"
                      maxlength="200"
                      prepend-inner-icon="mdi-account-outline"
                      :rules="[(v) => !!v || 'กรุณากรอกข้อมูลให้ครบถ้วน']"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b>Token BOT <span style="color: red">*</span></b>
                    <v-text-field
                      outlined
                      dense
                      color="#077893"
                      v-model="Token_Bot"
                      maxlength="1000"
                      prepend-inner-icon="mdi-account-outline"
                      :rules="[
                        (v) => !!(v && v.trim()) || 'กรุณากรอกข้อมูลให้ครบถ้วน',
                      ]"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <!-- <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b>Account id</b>
                    <v-text-field
                      hide-details
                      outlined
                      disabled
                      dense
                      color="#077893"
                      v-model="Account_ID"
                      prepend-inner-icon="mdi-account-outline"
                    ></v-text-field>
                  </v-flex>
                </v-layout> -->
              </v-card-text>
              <v-card-actions>
                <v-layout row wrap justify-center align-center pb-5>
                  <v-flex xs10 md3 lg3>
                    <v-btn
                      block
                      dark
                      color="#077893"
                      :loading="LoadingSave"
                      @click="Fn_CreateBot"
                      >{{ $t("policyForm.save") }}</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {},
  data: () => {
    return {
      BotName: "",
      Business_ID: "",
      Bot_ID: "",
      Token_Bot: "",
      Account_ID: "",
      LoadingSave: false,
      valid: true,
      SenderDisplayName: "",
      RuleEmailAddress: [
        (v) => !!v || "กรุณากรอกอีเมลแอดเดรสผู้ส่ง",
        (v) => /.+@.+\..+/.test(v) || "รูปแบบอีเมลไม่ถูกต้อง",
      ],
      RuleBotName: [(v) => !!(v && v.trim()) || "กรุณากรอกชื่อบอท"],
    };
  },
  computed: {},
  mounted() {
    this.SenderDisplayName = "";
    this.Account_ID = this.$cookies.get("OneAccountId");
    this.Business_ID = this.$cookies.get("BusinessId");
  },
  methods: {
    Fn_BackIndex() {
      this.$router.push("/config-bot");
    },
    async Fn_CreateBot() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        var Headers = {
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var auth = await authorization.encodeDataNew(Headers);
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/Bot",
            {
              Name: this.BotName,
              BusinessId: this.Business_ID,
              BotId: this.Bot_ID,
              TokenBot: this.Token_Bot,
              AccountId: this.Account_ID,
            },
            {
              headers: {
                Authorization: "Bearer " + auth,
                "ngrok-skip-browser-warning": "true",
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            Toast.fire({
              icon: "success",
              title: this.$i18n.t("SettingBot.add_bot_success"),
            });
            this.$router.push("/config-bot");
          })
          .catch((error) => {
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
  },
  watch: {},
};
</script>

<style></style>
